import { faker } from '@faker-js/faker';
import { UploadFileTypeEnum } from '@dynamika-shared/types/inventory';
import { Questionnaire } from '@dynamika-shared/types/questionnaire';
import { axiosMock } from '@api/client';
import { API_URL } from '@api/apiDictionary';

export function createRandomQuestionnaire(): Questionnaire {
  return {
    id: faker.string.uuid(),
    clinicalTrialId: faker.string.uuid(),
    alias: faker.lorem.word(),
    name: faker.lorem.words(),
    description: faker.lorem.sentence(),
    uiSchema: {},
    schema: {},
    modalities: faker.helpers.multiple(
      () => ({
        name: faker.lorem.word(),
        code: faker.string.alphanumeric(10),
        inputDataType: faker.helpers.enumValue(UploadFileTypeEnum),
        dataType: faker.helpers.enumValue(UploadFileTypeEnum),
        description: faker.lorem.sentence(),
      }),
      { count: faker.number.int({ min: 1, max: 5 }) }
    ),
  };
}
export function createRandomQuestionnaireItemList(
  count: number
): { id: string; name: string }[] {
  return faker.helpers.multiple(
    () => ({
      id: faker.string.uuid(),
      name: faker.lorem.words(),
    }),
    { count }
  );
}

export function createRandomQuestionnaireList(count: number): Questionnaire[] {
  return faker.helpers.multiple(createRandomQuestionnaire, { count });
}

export const createRandomQuestionnaireItemListMock = async () => {
  const data = createRandomQuestionnaireItemList(20);
  return axiosMock.onGet(API_URL.inventoryQuestionnaires).reply(200, data);
};
export const fetchClinicalTrialQuestionnairesMock = async () => {
  const data = createRandomQuestionnaireList(20);
  return axiosMock.onGet(API_URL.clinicalTrialQuestionnaires).reply(200, data);
};
